const ExcelIcon = () => {
    return (
        <i className="fa fa-file-excel" style={{ fontSize: 16, color: "green" }} />
    );
}

export default ExcelIcon;